export default __webpack_public_path__ + "media/images/arrow-b6581346359b615862e8d18db654f028.svg";